export enum RedirectType {
	Default = 'Default',
	Custom = 'Custom',
	Dashboard = 'Dashboard',
	None = 'None',
}
